/**
 * Removes the country from a string.
 *
 * Google Places API doesn't provide a way to remove the country,
 * and the only country we support is the US.
 */
export default function removeCountry(address) {
    if (typeof address === 'string') {
        return address
            .replace(', United States', '')
            .replace(', USA', '');
    }
}
